
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class TwShareButton extends Vue {
  @Prop({ required: true }) url: string
  @Prop({ default: '' }) text: string

  mounted() {
    setTimeout(() => {
      const twttr = (window as any).twttr
      if (twttr) {
        twttr.widgets.load()
      }
    }, 1000)
  }
}
